import { render, staticRenderFns } from "./CanvasArea.vue?vue&type=template&id=7bb54d14&scoped=true&"
import script from "./CanvasArea.vue?vue&type=script&lang=js&"
export * from "./CanvasArea.vue?vue&type=script&lang=js&"
import style0 from "./CanvasArea.vue?vue&type=style&index=0&id=7bb54d14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb54d14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bb54d14')) {
      api.createRecord('7bb54d14', component.options)
    } else {
      api.reload('7bb54d14', component.options)
    }
    module.hot.accept("./CanvasArea.vue?vue&type=template&id=7bb54d14&scoped=true&", function () {
      api.rerender('7bb54d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/CanvasArea.vue"
export default component.exports